import React from 'react';
import { Trans } from 'react-i18next';
import { Link } from 'react-router-dom';

export default function Hero2() {
    
    return (
        <div>
            <div className="container-fluid Hero2-container">
                <div className="layer2"></div>
                <div className="container Hero-Content-container">

                    <div className="row">
                        <div className="col-md-12 mb-4">
                            <h3 style={{ fontWeight: "500" }}>
                                <Trans i18nKey="heroTitle">نحن في</Trans>
                            </h3>
                            <h1 style={{ fontWeight: "500" }}>
                                <Trans i18nKey="heroSubTitle">عبدالله الجاسر للمحاماة والاستشارات القانونية</Trans>
                            </h1>
                        </div>
                        <div className="col-md-12 mb-4">
                            <p>
                                <Trans i18nKey="heroDescription">
                                    نضع عملاءنا في مقدمة أولوياتنا، ونعمل على تقديم خدمات قانونية موثوقة ومتوافقة مع الأنظمة والتشريعات. لا تتردد في التواصل معنا لأي استشارة قانونية، وسنكون سعداء بمساعدتك.
                                </Trans>
                            </p>
                        </div>
                        <div className="col-md-12">
                        <Link to="/info/contact">
                        <button className='HeroBtn py-3 px-2  py-md-3 px-md-4'>
                            <Trans i18nKey="BookBtn">   احجز استشارتك القانونية الآن </Trans>
                        </button>
                        </Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
